module.exports = __webpack_public_path__ + "media/images/common/mail/hokepon_reserve-280e9555640535293c3661bff018cac0.png";